import { t } from '@lingui/macro';
import { Api } from 'api';
import { FormControlFormSelect, FormControlFormSelectProps } from 'core';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { ExpertisePoint, ExpertisePointQueryCacheKey } from 'types';

export interface ExpertisePointSelectProps extends FormControlFormSelectProps {
  enableAll?: boolean;
  onExpertisePointSelected: (expertisePoint?: ExpertisePoint) => void;
  filterActive?: boolean;
  groupType?: number;
}

export const ExpertisePointSelect: React.FC<ExpertisePointSelectProps> = ({
  enableAll,
  onExpertisePointSelected,
  filterActive,
  groupType,
  ...selectedProps
}) => {
  const query = useQuery(
    [ExpertisePointQueryCacheKey.GetAllExpertisePoints, groupType],
    async () => {
      const response = await Api.ExpertisePoint.getAllExpertisePoints();
      let { data } = response;

      if (filterActive) {
        data = data.filter((expertisePoint) => expertisePoint.active);
      }

      if (groupType) {
        data = data.filter((expertisePoint) => expertisePoint.groupType === groupType);
      }

      return data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  const [expertisePointId, setExpertisePointId] = useState<string>();

  useEffect(() => {
    // Reset selection when groupType changes
    setExpertisePointId(enableAll ? '-1' : undefined);
    onExpertisePointSelected();
  }, [groupType]);

  useEffect(() => {
    if (enableAll && expertisePointId === '-1') {
      onExpertisePointSelected();
    } else if (query.data && expertisePointId && expertisePointId !== '-1') {
      const selectedExpertisePoint = query.data.find(
        (expertisePoint) => expertisePoint.id === parseInt(expertisePointId, 10),
      );

      if (selectedExpertisePoint) {
        onExpertisePointSelected(selectedExpertisePoint);
      }
    }
  }, [expertisePointId]);

  return (
    <FormControlFormSelect
      onChange={(event) => {
        setExpertisePointId(event.target.value);
      }}
      value={expertisePointId}
      defaultValue={enableAll ? -1 : undefined}
      placeholder={enableAll ? undefined : t`Bayi`}
      label={t`Bayi`}
      {...selectedProps}
    >
      {query.data && (
        <>
          {enableAll && <option value="-1">Hepsi</option>}
          {query.data.map((expertisePoint) => (
            <option key={`eps${expertisePoint.id}`} value={expertisePoint.id}>
              {expertisePoint.name}
            </option>
          ))}
        </>
      )}
    </FormControlFormSelect>
  );
};
